import { CircleCheckBig, TriangleAlert } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        const isDestructive = props.variant === "destructive";
        return (
          <Toast key={id} {...props}>
            <div className="flex items-start gap-3">
              <div className="pt-0.5">
                {isDestructive ? (
                  <TriangleAlert className="h-5 w-5 text-destructive-foreground" />
                ) : (
                  <CircleCheckBig className="h-5 w-5 text-white" />
                )}
              </div>
              <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
